import {fetchClientList} from '../../../services/externalDispute';


export function getClientList(myStr) {
    return new Promise(async (resolve, reject) => {
        try {
            let listOfClient=[]
             fetchClientList({}, myStr).then(async result => {
         result.data.data.map((client) =>
          (listOfClient[client.ClientMasterID] = client.CompanyName)
      );
      let response = {map:listOfClient}
      return resolve(response.map);
      })
        } catch (e) {
            console.log(`getClientList-${e.message}`);
        }
    });
   
  }




// WEBPACK FOOTER //
// ./src/services/B2b/services/getClientList.js